/* eslint-disable import/no-extraneous-dependencies */
import 'react-toastify/dist/ReactToastify.css';

import { toast } from 'react-toastify';

const returnListOfErrors = (error: any) => {
  const { message = 'Validation Error', fieldErrors: errors } = error || {};

  if (!errors || errors.length === 0) {
    return null;
  }

  if (errors.length > 1) {
    return (
      <>
        <span className="font-bold">{message}&nbsp;:</span>
        <ul>
          {errors?.map((errorMessage: any, errorIndex: number) => (
            <li key={errorIndex} className="ml-2 text-left">
              &ensp;
              {errorIndex + 1}
              {')'}&nbsp;{errorMessage.message}
            </li>
          ))}
        </ul>
      </>
    );
  }
  return <>{errors?.[0]?.message}</>;
};

const commonToastConfig = {
  position: 'top-right',
  autoClose: 5000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  theme: 'colored',
  closeButton: false,
} as any;

const useToast = () => {
  const toastSuccess = (message: any) => {
    if (message) toast.success(message, commonToastConfig);
  };

  const toastError = (error: any, message: any) => {
    // console.log(error, 'error');
    if (error?.fieldErrors?.length > 0) {
      // validation error
      const errorContent = returnListOfErrors(error);
      if (errorContent) {
        toast?.error(errorContent, commonToastConfig);
      }
    } else if (message) {
      // console.log('message', message);
      toast.error(message, commonToastConfig);
    }
  };

  const toastInfo = (message: any) => {
    if (message) toast.info(message, commonToastConfig);
  };

  return {
    toastSuccess,
    toastInfo,
    toastError,
  };
};

export default useToast;
